import { modifier } from 'ember-modifier';

import { call } from 'rise-ui/utils/function.js';

const focusTimeout = 100;

export default modifier((element, [callbacks, offFn]) => {
  const focus = () => setTimeout(() => element.focus(), focusTimeout);
  if (!callbacks || callbacks === true || callbacks === 'true') {
    focus();
    return () => {};
  }
  let [ on, off ] = [].concat(callbacks || []);
  off = offFn || off;
  call(on, null, focus);
  return () => call(off, null, focus);
});
